// extracted by mini-css-extract-plugin
export default {"title":"signIn_title__zb+Mx","desktopBox":"signIn_desktopBox__pmKRR","textInput":"signIn_textInput__YL7Ve","loaderWrapper":"signIn_loaderWrapper__RN9eb"};